export interface HoneypotFieldParams {
  index: number;
  value: string;
  firstInteractionMsRelativeToBoxCreation: number | null;
  firstInteractionEvent: 'focus' | 'input' | 'change' | null;
}
